import { IAzureFieldType, IAzureProject, OptionType } from '@evinced-private/ui-common';

import { AZURE_FORM_ACTION_TYPES } from './action-types';
import { AzureFormAction } from './actions';

/** Coordinated Azure form data — loaded/updated together, so it lives in one reducer. */
interface AzureFormState {
	host: string;
	projects: IAzureProject[];
	selectedProject: OptionType[];
	issueTypes: OptionType[];
	selectedIssueType: OptionType;
	fields: Record<string, IAzureFieldType>;
	screenshotUrl: string;
}

export const INITIAL_AZURE_FORM_STATE: AzureFormState = {
	host: null,
	projects: [],
	selectedProject: [],
	issueTypes: [],
	selectedIssueType: null,
	fields: null,
	screenshotUrl: ''
};

export function azureFormReducer(state: AzureFormState, action: AzureFormAction): AzureFormState {
	switch (action.type) {
		case AZURE_FORM_ACTION_TYPES.ORGANIZATION_RESOLVED:
			return {
				...state,
				host: action.host,
				projects: action.projects,
				selectedProject: action.selectedProject
			};
		case AZURE_FORM_ACTION_TYPES.PROJECT_DATA_LOADED:
			return {
				...state,
				projects: action.projects,
				issueTypes: action.issueTypes,
				selectedIssueType: action.selectedIssueType,
				fields: action.fields
			};
		case AZURE_FORM_ACTION_TYPES.PROJECT_SELECTED:
			return { ...state, host: action.host, selectedProject: action.selectedProject };
		case AZURE_FORM_ACTION_TYPES.ISSUE_TYPE_SELECTED:
			return { ...state, selectedIssueType: action.selectedIssueType };
		case AZURE_FORM_ACTION_TYPES.ISSUE_DATA_UPDATED:
			return {
				...state,
				fields: action.fields,
				screenshotUrl: action.screenshotUrl ?? state.screenshotUrl
			};
		case AZURE_FORM_ACTION_TYPES.FIELD_CHANGED:
			return {
				...state,
				fields: { ...state.fields, [action.field.referenceName]: action.field }
			};
		default:
			return state;
	}
}
